import RiskVerify from "../RiskVerify";
import { query, select, answer } from "./services";

// 核验版本
export const SDK_VERSION = "1.1.0";

// 核验场景
export enum EnumVerifyScene {
  // 风控
  risk,
  // 业务
  business,
}
// 核验-业务流程来源
export enum EnumBusinessFlow {
  //
  normal,
  // 1=密码登录
  passportLogin,
  // 2=密码修改
  passportReset,
  // 3=SPEI出金
  SPEICashout,
  // 4=sofi收银台
  SOFICashier,
  // 5=保存收款人-转账前
  payeeBeforeOrder,
  // 6=保存收款人-转账后
  payeeAfterOrder,
  // 7=下载对账单
  bankStatement,
  // 8=查看个人信息
  profile,
  // 9=查看受益人
  successorQuery,
  // 10=修改受益人
  successorUpdate,
  // 11=换设备登录
  device,
  mgm = 18,
  // 19=税务信息
  tax = 19,
  // 20=下载年度对账单
  bankStatementYearly = 20,
  // 26=放行核验
  riskHoldRelease = 26,
  // 27=撤销核验
  riskHoldCancel = 27,
  // 23=自定义转账限额修改
  transferLimit = 23,
  // 24=自定义支付限额修改
  paymentLimit = 24,
}

export default class BusinessVerify extends RiskVerify {
  constructor() {
    super({ query, select, answer });
    // console.log(this.service);
  }
  static scene: EnumVerifyScene = EnumVerifyScene.business;
}
